import { render } from "./NCalcTester.vue?vue&type=template&id=0fa74764&ts=true"
import script from "./NCalcTester.vue?vue&type=script&lang=ts"
export * from "./NCalcTester.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__